var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavouriteWithFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8,6.5C16,6.3,16,6,16,5.8c-0.1-0.2-0.3-0.4-0.6-0.5c-1.2-0.2-2.7-0.4-4.4-0.6c-0.1,0-0.3-0.2-0.4-0.3 c-0.7-1.5-1.4-2.9-2-4C8.5,0.1,8.3,0,8,0C7.7,0,7.5,0.1,7.4,0.4c-0.6,1.1-1.3,2.5-2,4C5.3,4.5,5.1,4.7,5,4.7 C3.3,4.9,1.9,5.1,0.6,5.3C0.3,5.4,0.1,5.5,0,5.8C0,6,0,6.3,0.2,6.5C1,7.4,2.1,8.7,3.4,10.1c0.1,0.1,0.2,0.3,0.1,0.5 c-0.4,1.5-0.7,3-1,4.4l-0.1,0.2c-0.1,0.5,0.2,0.7,0.2,0.7C2.7,15.9,2.8,16,3,16c0.1,0,0.3,0,0.5-0.2c0.6-0.4,1.3-0.8,1.9-1.2 c0.8-0.5,1.6-1,2.5-1.5c0,0,0.1-0.1,0.2-0.1s0.1,0,0.2,0.1c0.9,0.5,1.7,1,2.5,1.5c0.6,0.4,1.3,0.8,1.9,1.2c0.4,0.3,0.7,0.1,0.8,0 c0.1-0.1,0.3-0.3,0.2-0.8c-0.3-1.4-0.7-2.9-1.1-4.5c0-0.1,0-0.4,0.1-0.5C13.9,8.8,15,7.4,15.8,6.5z M11.5,10.8 c0.3,1.3,0.7,2.6,0.9,3.8c-0.4-0.3-0.9-0.5-1.3-0.8c-0.8-0.5-1.6-1-2.5-1.5c-0.4-0.3-1-0.3-1.4,0c-0.9,0.5-1.7,1-2.4,1.5 c-0.4,0.3-0.9,0.5-1.3,0.8c0.3-1.2,0.6-2.5,0.9-3.8c0.1-0.4,0-1-0.4-1.4C3,8.2,1.9,7.1,1.2,6.2C2.3,6,3.7,5.8,5.1,5.7 c0.5,0,1-0.4,1.2-0.8C6.9,3.5,7.5,2.3,8,1.3c0.5,1,1.1,2.3,1.7,3.5c0.2,0.4,0.7,0.8,1.2,0.8c1.4,0.2,2.8,0.3,3.9,0.5 c-0.7,0.9-1.8,2-2.9,3.3C11.6,9.8,11.4,10.4,11.5,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,10.8c0.3,1.3,0.7,2.6,0.9,3.8c-0.4-0.3-0.9-0.5-1.3-0.8c-0.8-0.5-1.6-1-2.5-1.5c-0.4-0.3-1-0.3-1.4,0 c-0.9,0.5-1.7,1-2.4,1.5c-0.4,0.3-0.9,0.5-1.3,0.8c0.3-1.2,0.6-2.5,0.9-3.8c0.1-0.4,0-1-0.4-1.4C3,8.2,1.9,7.1,1.2,6.2 C2.3,6,3.7,5.8,5.1,5.7c0.5,0,1-0.4,1.2-0.8C6.9,3.5,7.5,2.3,8,1.3c0.5,1,1.1,2.3,1.7,3.5c0.2,0.4,0.7,0.8,1.2,0.8 c1.4,0.2,2.8,0.3,3.9,0.5c-0.7,0.9-1.8,2-2.9,3.3C11.6,9.8,11.4,10.4,11.5,10.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteWithFill);
export default __webpack_public_path__ + "static/media/favourite-with-fill.2596d9e2f3b0279d6a73555a4aacfbdd.svg";
export { ForwardRef as ReactComponent };